<div class="dialog-container message-dialog">
    <div class="dialog-heading">
        <span class="spacer"></span>
        <div class="btn-close">
            <button mat-icon-button aria-label="Close Dialog" (click)="onClose()"><mat-icon>close</mat-icon></button>
        </div>
    </div>
    <mat-dialog-content>
        <p class="dialog-message" innerHTML="{{message}}"></p>
    </mat-dialog-content>
</div>